const EventsList = () => import('Views/events/events-list');
const EventsDetail = () => import('Views/events/events-detail-new-ui');

export default[
  { path: '/events-list', component: EventsList },
  { path: '/events-detail/:id', component: EventsDetail },
];



// WEBPACK FOOTER //
// ./src/router/events.js